module.exports = __webpack_public_path__ + "static/media/44.9c9d479a.jpg";